<template>
  <component :is="page" />
</template>

<script>
export default {
  computed: {
    page() {
      // 현재는 신규 신청 폼만 활성
      // const name = this.$route.query?.wholesaler ? 'FormByWholesaler.vue' : 'RegisterForm.vue'
      // return () => import(`@/components/credit-pay/${name}`)
      return () => import('@/components/credit-pay/request/RegisterForm.vue')
    },
  },
}
</script>
